export const PRIMARY_COLOR = "#092C4C";
export const SECONDARY_COLOR = "#74BDE9";
